import {
  ArrowLeft,
  User,
  ChevronDown,
  ChevronUp,
  Search,
  Tag,
  Package,
  ExternalLink,
  TrendingUp,
  ShoppingBag,
} from "lucide-react";


// Real WhatsApp SVG Icon
const WhatsAppIcon = ({ className = "w-4 h-4", fill = "#25D366" }) => (
  <svg className={className} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

// Real Instagram SVG Icon
const InstagramIcon = ({ className = "w-4 h-4", fill = "#E1306C" }) => (
  <svg className={className} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

export default function VisitorDetail({
  visitorId,
  staticId,
  visitorEmail,
  journey,
  topBrands,
  collapsedActions,
  expandedSessions,
  onBack,
  onViewAssistantChats,
  toggleSession,
  toggleActionCollapse,
  getActionKey,
  isCollapsibleAction,
  getActionIcon,
  getActionColor,
  getActionBadgeColor,
  getActionLabel,
  formatTimestamp,
  formatDate,
  onViewSpecificChat,
}) {
  const groupBySession = (journey) => {
    const sessions = {};
    journey.forEach((step) => {
      if (!sessions[step.session_id]) sessions[step.session_id] = [];
      sessions[step.session_id].push(step);
    });
    return sessions;
  };

  const sessions = groupBySession(journey);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      {/* BACK */}
      <button
        onClick={onBack}
        className="flex items-center text-gray-600 hover:text-gray-900 mb-6 font-semibold transition"
      >
        <ArrowLeft className="w-5 h-5 mr-2" />
        Back to Visitors List
      </button>

      {/* HEADER */}
      <div className="bg-white rounded-xl shadow-lg mb-6 overflow-hidden">
        <div className="bg-gradient-to-r from-indigo-500 to-purple-600 p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="bg-white bg-opacity-20 p-3 rounded-full mr-4">
                <User className="w-8 h-8 text-white" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white mb-1 flex items-center flex-wrap gap-2">
                  Visitor Journey {staticId ? `(ID: ${staticId})` : ""}
                  {visitorEmail && <span className="text-indigo-600 bg-indigo-50 px-3 py-0.5 rounded-full text-lg font-sans tracking-wide shadow-sm">{visitorEmail}</span>}
                </h2>
                <p className="text-sm text-white text-opacity-80 font-mono">
                  UUID: {visitorId}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="bg-white bg-opacity-20 px-4 py-2 rounded-full">
                <span className="text-white font-semibold">
                  {Object.keys(sessions).length} Session
                  {Object.keys(sessions).length > 1 ? "s" : ""}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* STATS & BRANDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-50 p-6">
          <div className="flex flex-col border-r pr-4">
            <div className="grid grid-cols-3 gap-4 mb-4">
              <Stat label="Total Actions" value={journey.length} />
              <Stat label="Sessions" value={Object.keys(sessions).length} />
              <Stat
                label="Buy Clicks"
                value={
                  journey.filter((s) => s.action === "checkout_redirect").length
                }
              />
            </div>
            {onViewAssistantChats && journey.some(s => s.action === "assistant_interaction") && (
              <button
                onClick={onViewAssistantChats}
                className="w-full bg-indigo-50 text-indigo-700 hover:bg-indigo-100 font-semibold py-2 rounded-lg transition text-sm flex items-center justify-center border border-indigo-200"
              >
                View All AI Assistant Chats
              </button>
            )}
          </div>
          <div className="pl-4">
            <p className="text-sm text-gray-600 mb-2 font-semibold">Most Clicked Brands</p>
            {topBrands && topBrands.length > 0 ? (
              <div className="flex flex-wrap gap-2">
                {topBrands.slice(0, 5).map(b => (
                  <span key={b.brand} className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                    {b.brand} <span className="bg-green-200 px-1.5 py-0.5 rounded ml-1 text-xs">{b.count}</span>
                  </span>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-400">No brand clicks yet.</p>
            )}
          </div>
        </div>
      </div>

      {/* JOURNEY */}
      <div className="bg-white rounded-xl shadow-lg p-6">
        {Object.entries(sessions).reverse().map(([sessionId, steps], index) => {
          const totalSessions = Object.keys(sessions).length;
          const displaySessionNum = totalSessions - index;
          return (
            <div key={sessionId} className="mb-6 last:mb-0">
              <button
                onClick={() => toggleSession(sessionId)}
                className="w-full flex items-center justify-between bg-gray-50 hover:bg-gray-100 p-4 rounded-lg transition mb-4"
              >
                <div className="flex items-center">
                  <h4 className="text-lg font-semibold text-gray-900 mr-3">
                    Session {displaySessionNum}
                  </h4>
                  <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-sm font-medium">
                    {steps.length} actions
                  </span>
                  <span className="ml-3 text-sm text-gray-500">
                    {formatDate(steps[0].timestamp)}
                  </span>
                </div>
                {expandedSessions[sessionId] ? <ChevronUp /> : <ChevronDown />}
              </button>

              {expandedSessions[sessionId] && (
                <div className="pl-4">
                  {steps.map((step, idx) => {
                    const actionKey = getActionKey(sessionId, idx);
                    const isCollapsed = collapsedActions[actionKey] ?? true;
                    const canCollapse = isCollapsibleAction(step.action);

                    return (
                      <div key={idx} className="flex mb-6 last:mb-0 relative">
                        <div className="flex flex-col items-center mr-4 relative z-10">
                          <div
                            className={`w-12 h-12 rounded-full flex items-center justify-center ${getActionColor(step.action, step)} border-2 bg-white`}
                          >
                            {getActionIcon(step.action, step)}
                          </div>
                        </div>

                        {idx < steps.length - 1 && (
                          <div className="absolute left-6 top-12 bottom-[-1.5rem] w-0.5 bg-gray-300 z-0 -ml-[1px]" />
                        )}

                        <div
                          className={`flex-1 p-4 rounded-lg border-2 ${getActionColor(step.action, step)} relative z-10 bg-white`}
                        >
                          {/* HEADER */}
                          <div className="flex justify-between items-center mb-3">
                            <span
                              className={`px-3 py-1 rounded-full text-sm font-semibold ${getActionBadgeColor(step.action, step)}`}
                            >
                              {getActionLabel(step.action, step)}
                            </span>

                            <div className="flex items-center gap-3">
                              {canCollapse && (
                                <button
                                  onClick={() => toggleActionCollapse(actionKey)}
                                  className="text-sm text-indigo-600 hover:underline flex items-center gap-1"
                                >
                                  {isCollapsed ? "Show" : "Hide"}
                                  {isCollapsed ? (
                                    <ChevronDown className="w-4 h-4" />
                                  ) : (
                                    <ChevronUp className="w-4 h-4" />
                                  )}
                                </button>
                              )}

                              <span className="text-sm text-gray-600">
                                {formatTimestamp(step.timestamp)}
                              </span>
                            </div>
                          </div>

                          {/* DATA */}
                          <ActionContent step={step} isCollapsed={isCollapsed} onViewSpecificChat={onViewSpecificChat} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="text-center">
      <p className="text-sm text-gray-600 mb-1">{label}</p>
      <p className="text-2xl font-bold text-gray-900">{value}</p>
    </div>
  );
}

function ActionContent({ step, isCollapsed, onViewSpecificChat }) {
  if (step.action === "search") {
    return (
      <>
        <p>
          Search Query: "{step.data.keyword}"
          {step.data.gender && (
            <span className="text-gray-500 text-sm ml-2">
              ({step.data.gender})
            </span>
          )}
          {step.data.brandsearch_label && (
            <span className="text-gray-500 text-sm ml-2">
              ({step.data.brandsearch_label})
            </span>
          )}
        </p>
        {step.data.location && (
          <p>Location: {step.data.location || "Unknown"}</p>
        )}
      </>
    );
  }

  if (step.action === "category_click") {
    return (
      <>
        <p>Category: {step.data.category}</p>
      </>
    );
  }

  if (step.action === "image_search_buy_click") {
    return (
      <>
        <p className="font-semibold text-gray-800">
          Identified Product:{" "}
          <span className="font-normal">
            {step.data.product_title || "Unknown"}
          </span>
        </p>
        {step.data.brand && (
          <p className="font-semibold text-gray-800 mt-1">
            Brand:{" "}
            <span className="font-normal text-green-700 bg-green-50 px-2 py-0.5 rounded">
              {step.data.brand}
            </span>
          </p>
        )}
        {step.data.product_url && (
          <a
            href={step.data.product_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline block mt-2 break-all hover:text-blue-800 transition"
          >
            {step.data.product_url}
          </a>
        )}
      </>
    );
  }

  if (step.action === "product_click") {
    return (
      <>
        <p className="font-semibold text-gray-800">
          Product:{" "}
          <span className="font-normal">
            {step.data.product?.title ||
              step.data.product_title ||
              step.data.product?.product_id}
          </span>
        </p>
        {(step.data.product?.brand || step.data.brand) && (
          <p className="font-semibold text-gray-800 mt-1">
            Brand:{" "}
            <span className="font-normal text-green-700 bg-green-50 px-2 py-0.5 rounded">
              {step.data.product?.brand || step.data.brand}
            </span>
          </p>
        )}
        {(step.data.product?.image_url || step.data.product_image) && (
          <img
            src={step.data.product?.image_url || step.data.product_image}
            alt="Product"
            referrerPolicy="no-referrer"
            className="mt-3 rounded shadow-sm w-24 h-24 object-cover"
          />
        )}
      </>
    );
  }

  if (step.action === "checkout_redirect") {
    const rawChannel = (step.data?.channel || step.data?.source || "website").toLowerCase();
    const isWhatsApp = rawChannel === "whatsapp";
    const isInstagram = rawChannel === "instagram";
    const isDirectOrder = rawChannel === "direct_order";
    const isWebsite = !isWhatsApp && !isInstagram && !isDirectOrder;

    return (
      <div className="space-y-2.5">
        {/* Source Channel Identifier */}
        <div className="flex items-center gap-2">
          <span className="font-semibold text-gray-800 text-sm">Source:</span>
          {isWhatsApp && (
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-emerald-50 text-emerald-700 border border-emerald-200 shadow-2xs">
              <WhatsAppIcon className="w-3.5 h-3.5" fill="#25D366" />
              WhatsApp
            </span>
          )}
          {isInstagram && (
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-pink-50 text-pink-700 border border-pink-200 shadow-2xs">
              <InstagramIcon className="w-3.5 h-3.5" fill="#E1306C" />
              Instagram
            </span>
          )}
          {isDirectOrder && (
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-indigo-50 text-indigo-700 border border-indigo-200 shadow-2xs">
              <ShoppingBag className="w-3.5 h-3.5 text-indigo-600" />
              Direct Order
            </span>
          )}
          {isWebsite && (
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-gray-100 text-gray-700 border border-gray-200 shadow-2xs">
              <ExternalLink className="w-3.5 h-3.5 text-gray-500" />
              Website
            </span>
          )}
        </div>

        {/* Product Title */}
        {step.data?.product_title && (
          <p className="font-semibold text-gray-800 text-sm">
            Product:{" "}
            <span className="font-normal text-gray-900">
              {step.data.product_title}
            </span>
          </p>
        )}

        {/* Brand, SKU, Price */}
        {(step.data?.brand || step.data?.product_id || step.data?.product_price) && (
          <div className="flex flex-wrap items-center gap-3 text-xs text-gray-600">
            {step.data.brand && (
              <span>
                Brand: <strong className="text-gray-900">{step.data.brand}</strong>
              </span>
            )}
            {step.data.product_id && (
              <span>
                SKU: <strong className="font-mono text-gray-900">{step.data.product_id}</strong>
              </span>
            )}
            {step.data.product_price && (
              <span>
                Price:{" "}
                <strong className="text-emerald-600 font-bold">
                  {step.data.currency || "PKR"} {parseFloat(step.data.product_price).toLocaleString()}
                </strong>
              </span>
            )}
          </div>
        )}

        {/* Customer Details (for Direct Orders) */}
        {(step.data?.customer_name || step.data?.customer_phone || step.data?.customer_address) && (
          <div className="p-3 bg-gray-50/80 rounded-lg border border-gray-200 text-xs space-y-1.5">
            <div className="font-bold text-gray-800 text-xs uppercase tracking-wide">Customer Details:</div>
            {step.data.customer_name && (
              <div className="text-gray-700">
                Name: <span className="font-semibold text-gray-900">{step.data.customer_name}</span>
              </div>
            )}
            {step.data.customer_phone && (
              <div className="text-gray-700">
                Phone: <span className="font-semibold font-mono text-gray-900">{step.data.customer_phone}</span>
              </div>
            )}
            {step.data.customer_address && (
              <div className="text-gray-700">
                Address: <span className="font-medium text-gray-900">{step.data.customer_address}</span>
              </div>
            )}
            {(step.data.selected_size || step.data.selected_color) && (
              <div className="flex gap-2 pt-1 text-[11px]">
                {step.data.selected_size && (
                  <span className="px-2 py-0.5 bg-white rounded border border-gray-200 font-medium text-gray-800">
                    Size: {step.data.selected_size}
                  </span>
                )}
                {step.data.selected_color && (
                  <span className="px-2 py-0.5 bg-white rounded border border-gray-200 font-medium text-gray-800">
                    Color: {step.data.selected_color}
                  </span>
                )}
              </div>
            )}
          </div>
        )}

        {/* Product Image */}
        {step.data?.product_image && (
          <img
            src={step.data.product_image}
            alt="Product"
            referrerPolicy="no-referrer"
            className="mt-2 rounded-lg shadow-xs w-24 h-24 object-cover border border-gray-200"
          />
        )}

        {/* Redirect / Target URL */}
        {(step.data?.redirect_url || step.data?.product_url) && (
          <div className="pt-1">
            <a
              href={step.data.redirect_url || step.data.product_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs text-blue-600 hover:text-blue-800 underline break-all"
            >
              <span>{step.data.redirect_url || step.data.product_url}</span>
              <ExternalLink className="w-3.5 h-3.5 flex-shrink-0" />
            </a>
          </div>
        )}
      </div>
    );
  }

  if (["new_arrivals_visit", "on_sale_visit", "view_all_visit"].includes(step.action)) {
    return (
      <>
        <p className="font-semibold text-gray-800">
          Brand:{" "}
          <span className="font-normal text-indigo-700 bg-indigo-50 px-2 py-0.5 rounded">
            {step.data.brand || "Unknown"}
          </span>
        </p>
      </>
    );
  }

  if (step.action === "image_search") {
    return (
      <>
        <p className="text-gray-600 mb-2">Image Search Upload</p>
        {step.data.image_url && (
          <img
            src={step.data.image_url}
            alt="Search Input"
            className="mt-2 rounded-lg border shadow-sm max-w-full h-auto max-h-48 object-cover"
          />
        )}
      </>
    );
  }

  if (step.action === "assistant_results_viewed") {
    return (
      <div className="flex justify-between items-start">
        <div className="flex flex-col gap-2">
          <p className="font-semibold text-gray-800">
            Results Viewed:{" "}
            <span className="font-normal text-indigo-700 bg-indigo-50 px-2 py-0.5 rounded">
              {step.data.count || 0} products
            </span>
          </p>
        </div>
        {step.data.chat_thread_id && onViewSpecificChat && (
          <button
            onClick={() => onViewSpecificChat(step.data.chat_thread_id)}
            className="text-sm text-indigo-600 hover:text-indigo-800 font-medium whitespace-nowrap bg-indigo-50 hover:bg-indigo-100 px-3 py-1 rounded transition-colors ml-4"
          >
            Open Chat Thread &rarr;
          </button>
        )}
      </div>
    );
  }

  if (step.action === "assistant_interaction") {
    return (
      <div className="flex justify-between items-start mt-2 bg-gray-50 p-3 rounded border">
        <div className="flex flex-col gap-2">
          <p className="text-sm font-semibold text-gray-800">
            User: <span className="font-normal text-gray-600">"{step.data.user_message}"</span>
          </p>
          <p className="text-sm font-semibold text-gray-800">
            AI Response: <span className="font-normal text-gray-600">{step.data.ai_response}</span>
          </p>
          {step.data.ai_search_query?.keyword && (
            <p className="text-xs text-indigo-600 mt-1 font-medium">
              → Executed Search: "{step.data.ai_search_query.keyword}" ({step.data.returned_products || 0} results)
            </p>
          )}
        </div>
        {step.data.chat_thread_id && onViewSpecificChat && (
          <button
            onClick={() => onViewSpecificChat(step.data.chat_thread_id)}
            className="text-sm text-indigo-600 hover:text-indigo-800 font-medium whitespace-nowrap bg-indigo-100 hover:bg-indigo-200 px-3 py-1 rounded transition-colors ml-4"
          >
            Open Chat Thread &rarr;
          </button>
        )}
      </div>
    );
  }

  return null;
}
